import { processResultStateEnum } from "./dataStruct";

/** AEO HOGE ceiling margin controls failure; OEI HOGE is informational. insufficient CAT-A performance is advisory only. */
export function performanceStatus(
  hogeDepartureMargin: number,
  hogeDestinationMargin: number,
  catADepartureMargin: number,
  catADestinationMargin: number
): processResultStateEnum {
  const passes = (margin: number) => Number.isFinite(margin) && margin > 0;
  if (!passes(hogeDepartureMargin) || !passes(hogeDestinationMargin)) return processResultStateEnum.fail;
  if (!passes(catADepartureMargin) || !passes(catADestinationMargin)) return processResultStateEnum.warn;
  return processResultStateEnum.ok;
}
